import React from "react";


export function SectionHero() {
  return(
    <>
      <div className="container">
        <div class="section-hero__header">
          <img class="section-hero__image" src="https://aui.atlassian.com/aui/latest/docs/images/avatar-person.svg" alt="avatar" />
          <h1 class="section-hero__title">FrontEnd Dev</h1>
          <h4 class="section-hero__subtitle">Personal Web Page</h4>
        </div>
      </div>
    </>
  )
}
